import React from "react";
import { apiUrls } from "../../../actprep-ui/utils/urls";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import PaginatedTable from "../../../actprep-ui/components/PaginatedTable";
import layout from "../../../actprep-ui/constants/layout";
import CategoryForm from "../../../components/EditCategoryForm/EditCategoryForm";
import { sortingModes } from "../../../actprep-ui/constants/dataGrid";

export default function Categories() {
  const categoriesColumns = () => [
    {
      field: "name",
      headerName: "Name",
      width: 200,
    },
    {
      field: "group",
      headerName: "Group",
      width: 200,
    },
    {
      field: "subject",
      headerName: "Subject",
      width: 150,
    },
  ];

  return (
    <Grid
      sx={{
        marginTop: `${layout.navBarHeight + 1}rem`,
      }}
      size={12}
    >
      <ContentBox style={{ maxHeight: "80vh", height: "500rem" }}>
        <Typography variant="h5" fontWeight={"bold"}>
          Categories
        </Typography>
        <Box sx={{ height: "90%" }}>
          <PaginatedTable
            searchable
            tableName={"Categories"}
            addRowButtonText="Add Category"
            apiUrl={apiUrls.admin.categories()}
            columns={categoriesColumns}
            urlParams={{
              keep_related: "true",
            }}
            initialState={{
              pinnedColumns: {
                right: ["actions"],
              },
            }}
            sortingMode={sortingModes.SERVER}
            disableCellFocus
            getRowTitle={({ row }) => row?.name}
            EditForm={CategoryForm}
            CreationForm={CategoryForm}
          />
        </Box>
      </ContentBox>
    </Grid>
  );
}
